;(function () {
	const sectionId = window.Shopify.CustomizableProduct.sectionId
	const section = document.querySelector('.customizable-product-section')
	const partsData = window.Shopify.CustomizableProduct.parts
	const formsToggle = document.querySelector('#ToggleForms-' + sectionId)
	const formsContainer = document.querySelector('#Forms-' + sectionId)
	const frameForm = document.querySelector(
		'#AddToCartForm-' + partsData.frame.id
	)
	const lensForm = document.querySelector(
		'#AddToCartForm-' + partsData.lens.id
	)
	const jawForm =
		partsData.jaw &&
		document.querySelector('#AddToCartForm-' + partsData.jaw.id)
	const atcBtn = document.querySelector('#AddToCart-' + sectionId)
	const minicartSection = section.querySelector('.section--minicart')
	const atcMiniBtn = document.querySelector('#AddToCartMinicart-' + sectionId)
	const backInStockBtn = document.querySelector('#BackInStock-' + sectionId)
	const jawToggle =
		partsData.jaw && document.querySelector('#jaw-enable-checkbox')
	const combosForm = document.querySelector('#combos')
	const comboRadios = document.querySelectorAll('#combos input[type=radio]')
	const formTabButtons = document.querySelectorAll(
		'.customizable-tabs button'
	)
	const allFormRadios = document.querySelectorAll(
		'[id^=AddToCartForm-] input[type=radio]'
	)
	const allForms = document.querySelectorAll('[id^=AddToCartForm-]')
	const previewLoader = document.querySelector('.preview-loader')
	const previewContainer = document.querySelector('#preview-container')
	const previewContainer1 = document.querySelector(
		'#preview-container-side-1'
	)
	const previewContainer2 = document.querySelector(
		'#preview-container-side-2'
	)
	const previewContainer3 = document.querySelector(
		'#preview-container-side-3'
	)
	const previewContainer4 = document.querySelector(
		'#preview-container-side-4'
	)
	const previewModal = document.querySelector('#preview-modal')
	const previewModalCloseBtn = document.querySelector(
		'#preview-modal .close-btn'
	)
	const previewModalPrevBtn = document.querySelector(
		'#preview-modal .prev-btn'
	)
	const previewModalNextBtn = document.querySelector(
		'#preview-modal .next-btn'
	)
	const warnPopup = document.querySelector('.customizable-popup-warn')
	const warnPopupCancelButton = document.querySelector(
		'#customizable-popup-warn-cancel'
	)
	const warnPopupConfirmButton = document.querySelector(
		'#customizable-popup-warn-confirm'
	)
	const warnPopupOverlay = document.querySelector(
		'.customizable-popup-warn-overlay'
	)
	const accessoryCheckboxes = document.querySelectorAll(
		".group--accessories input[name='variant']"
	)
	const accessoryATCs = document.querySelectorAll('.js-accsessories-submit')
	const LAYERS_COUNT = partsData.jaw ? 3 : 2

	window.addEventListener('scroll', function () {
		if (window.scrollY > 0) {
			section.classList.add('scrolled')
		} else {
			section.classList.remove('scrolled')
		}
	})
	allFormRadios.forEach(function (radio) {
		radio.addEventListener('click', onVariantChange)
	})
	formTabButtons.forEach(function (btn) {
		btn.addEventListener('click', onTabChange)
	})
	jawToggle?.addEventListener('click', onJawToggle)
	jawToggle?.addEventListener('change', onJawToggleChange)
	comboRadios.forEach(function (radio) {
		radio.addEventListener('click', onComboChange)
	})
	formsToggle.addEventListener('click', onFormsToggle)
	atcBtn.addEventListener('click', onAtcClick)
	atcMiniBtn.addEventListener('click', onAtcClick)
	backInStockBtn.addEventListener('click', onBackInStockClick)
	window.addEventListener('load', setVariantsFromParams)
	previewContainer1.addEventListener('click', changeThumb)
	previewContainer2.addEventListener('click', changeThumb)
	previewContainer3.addEventListener('click', changeThumb)
	previewContainer4.addEventListener('click', changeThumb)
	previewContainer.addEventListener('click', openModal)
	previewContainer.addEventListener('swipe', function (e) {
		onSwipe(e.detail.deltaX)
	})
	previewModalCloseBtn.addEventListener('click', closeModal)
	previewModalPrevBtn.addEventListener('click', onPrevModalImg)
	previewModalNextBtn.addEventListener('click', onNextModalImg)
	warnPopupConfirmButton.addEventListener('click', onConfirmWarnPopup)
	warnPopupCancelButton.addEventListener('click', hideWarnPopup)
	warnPopupOverlay.addEventListener('click', hideWarnPopup)

	// TODO: fix this
	window.CustomizableATC = addToCart

	const observerCallback = (entries, observer) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				minicartSection.classList.add('mini-show')
			} else {
				minicartSection.classList.remove('mini-show')
			}
		})
	}
	const observer = new IntersectionObserver(observerCallback, {
		root: null,
		threshold: 0,
		rootMargin: '-200px 0px 0px 0px',
	}).observe(atcBtn)

	setupPreviewSwipe()

	function setVariantsFromParams() {
		const urlParams = new URLSearchParams(document.location.search)
		const paramVariantIds = {
			frame: urlParams.get('frame'),
			lens: urlParams.get('lens'),
			jaw: urlParams.get('jaw'),
		}
		if (
			paramVariantIds.frame &&
			paramVariantIds.lens &&
			(paramVariantIds.jaw || !partsData.jaw)
		) {
			frameForm
				.querySelector(
					'input[data-variant-id="' + paramVariantIds.frame + '"]'
				)
				.click()
			lensForm
				.querySelector(
					'input[data-variant-id="' + paramVariantIds.lens + '"]'
				)
				.click()
			jawForm
				?.querySelector(
					'input[data-variant-id="' + paramVariantIds.jaw + '"]'
				)
				.click()
		} else if (urlParams.has('variant')) {
			combosForm
				.querySelector(
					'input[data-variant-id="' + urlParams.get('variant') + '"]'
				)
				.click()
		}
		setProductType()
	}

	function onVariantChange() {
		updateProductFormInfo()
		selectMatchingCombo()
		updateImagePreview()
		setProductType()
	}

	function selectMatchingCombo() {
		const checkedRadios = formsContainer.querySelectorAll(
			'input[type=radio]:checked'
		)
		const selectedVariantIdsStr = Array.from(checkedRadios)
			.map((radio) => radio.value)
			.join(',')
		const isJawEnabledInToggle = Boolean(jawToggle?.checked)
		let foundCorrespondingCombo = false
		comboRadios.forEach(function (radio, index) {
			if (!radio.value) return
			const idsMatch = radio.value === selectedVariantIdsStr
			const comboJawVariantId = radio.value.split(',')[2]

			let isJawStateMatch = true
			if (partsData.jaw) {
				const isJawEnabledInCombo =
					partsData.jaw.variants[Number(comboJawVariantId)].title !==
					'None'
				isJawStateMatch = isJawEnabledInCombo === isJawEnabledInToggle
			}

			if (idsMatch && isJawStateMatch) {
				radio.checked = true
				foundCorrespondingCombo = radio.dataset.variantId
				return
			}
		})
		const url = new URL(window.location.href)
		if (!foundCorrespondingCombo) {
			document.querySelector('#ComboRadios-None').checked = true
			url.searchParams.delete('variant')
		} else {
			url.searchParams.set('variant', foundCorrespondingCombo)
		}
		window.history.replaceState({}, '', url.toString())
	}

	function updateProductFormInfo() {
		let totalPrice = 0
		let hasUnavailablePart = false
		const variantTitles = { frame: '', lens: '', jaw: '' }

		allForms.forEach(function (form) {
			const radios = form.querySelectorAll('input[type=radio]')
			radios.forEach(function (radio) {
				if (radio.checked) {
					const variantId = radio.value
					const variantPrice =
						partsData[form.dataset.partHandle].variants[variantId]
							.price
					const isJawEnabled = !radio.disabled
					const isVariantUnavailable =
						radio.classList.contains('disabled')
					const partHandle = form.dataset.partHandle
					const variantTitle =
						partsData[partHandle].variants[variantId].title

					if (isJawEnabled) {
						totalPrice += variantPrice
					}
					if (isVariantUnavailable) {
						hasUnavailablePart = true
					}
					variantTitles[partHandle] = variantTitle
				}
			})
		})

		const formattedPrice = window.theme.Currency.formatMoney(
			totalPrice,
			theme.settings.moneyFormat
		)
		document.querySelector('#ProductPrice-' + sectionId).innerText =
			formattedPrice

		atcBtn.disabled = hasUnavailablePart
		atcMiniBtn.disabled = hasUnavailablePart

		allForms.forEach(function (form) {
			form.querySelector('.group__titleValue').innerText =
				variantTitles[form.dataset.partHandle]
		})

		if (partsData.jaw) {
			const jawNoneRadio = jawForm.querySelector(
				'input[type=radio].none-variant'
			)
			jawToggle.checked = !jawNoneRadio.checked
			jawToggle.dispatchEvent(new Event('change'))
		}

		updateMinicart(
			Object.values(variantTitles)
				.filter((title) => title !== 'None')
				.filter(Boolean)
				.join(', '),
			formattedPrice,
			hasUnavailablePart
		)
	}

	function getImages(variantIds, side, size = null) {
		const layerImgUrls = []
		for (let layer = 1; layer <= LAYERS_COUNT; layer++) {
			let layerImgUrl
			for (
				let partHandleIndex = 0;
				partHandleIndex < LAYERS_COUNT;
				partHandleIndex++
			) {
				const partVariantId = variantIds[partHandleIndex]
				const partHandle = Object.keys(partsData)[partHandleIndex]
				const url =
					partsData[partHandle].variants[partVariantId].images.sides[
						String(side)
					].layers[String(layer)]
				if (url) {
					layerImgUrl = !size
						? url
						: url?.replace('.png', '_' + size + 'x.png')
					break
				}
			}
			layerImgUrls.push(layerImgUrl)
		}
		return layerImgUrls
	}

	function getSelectedVariantIds() {
		const selectedVariantIds = Array.from(allForms).map(function (form) {
			const radios = form.querySelectorAll('input[type=radio]')
			const variantId = Array.from(radios).find(function (radio) {
				return radio.checked
			}).value
			return variantId
		})
		return selectedVariantIds
	}

	function updateImagePreview() {
		previewContainer.classList.add('opaque')
		previewLoader.classList.add('show')

		const allPreviewThumbnailContainers = [
			previewContainer1,
			previewContainer2,
			previewContainer3,
			previewContainer4,
		]

		const imgEls = []
		const srcSets = []
		const srcs = []

		const selectedVariantIds = getSelectedVariantIds()
		for (let side = 1; side <= 4; side++) {
			const sideImages = getImages(selectedVariantIds, side)
			for (let layerIndex = 0; layerIndex < LAYERS_COUNT; layerIndex++) {
				const layerImage = sideImages[layerIndex]
				imgEls.push(
					allPreviewThumbnailContainers[side - 1].querySelector(
						"[data-layer='" + String(layerIndex + 1) + "']"
					)
				)
				srcSets.push(getThumbSrcset(layerImage, '40'))
				srcs.push(layerImage?.replace('.png', '_40x.png'))
				if (String(side) === previewContainer.dataset.side) {
					imgEls.push(
						previewContainer.querySelector(
							"[data-layer='" + String(layerIndex + 1) + "']"
						)
					)
					srcSets.push(getMainSrcset(layerImage, '1000'))
					srcs.push(layerImage?.replace('.png', '_1000x.png'))
				}
			}
		}

		loadImages(imgEls, srcSets, srcs).then(() => {
			previewContainer.classList.remove('opaque')
			previewLoader.classList.remove('show')
		})
	}

	function onTabChange(e) {
		e.preventDefault()
		formsContainer.dataset.current = e.target.dataset.part
	}

	function onJawToggle(e) {
		let newJawRadio
		if (jawToggle.checked) {
			newJawRadio = jawForm.querySelector('input[type=radio]')
		} else {
			newJawRadio = jawForm.querySelector(
				'input[type=radio].none-variant'
			)
		}
		newJawRadio.click()
	}

	function onJawToggleChange(e) {
		if (e.target.checked) {
			jawForm.classList.remove('opaque')
		} else {
			jawForm.classList.add('opaque')
		}
	}

	function onComboChange(e) {
		if (!e.target.value) return
		const variantIds = e.target.value.split(',')
		frameForm
			.querySelector('input[data-variant-id="' + variantIds[0] + '"]')
			.click()
		lensForm
			.querySelector('input[data-variant-id="' + variantIds[1] + '"]')
			.click()
		jawForm
			?.querySelector('input[data-variant-id="' + variantIds[2] + '"]')
			?.click()
	}

	function onFormsToggle(e) {
		e.preventDefault()
		formsContainer.classList.toggle('show')
		e.currentTarget.classList.toggle('arrow-up')
		e.currentTarget.children[0].innerText =
			formsContainer.classList.contains('show')
				? window?.Shopify?.CustomizableProduct?.translations
						?.hide_customize_button || 'Hide details'
				: window?.Shopify?.CustomizableProduct?.translations
						?.customize_button || 'Customize'
		if (formsContainer.classList.contains('show')) {
			e.currentTarget.classList.add('btn--plain')
			e.currentTarget.classList.remove('btn--gradient-accent')

			combosForm.classList.add('hidden-combos')
		} else {
			e.currentTarget.classList.add('btn--gradient-accent')
			e.currentTarget.classList.remove('btn--plain')

			combosForm.classList.remove('hidden-combos')
		}
	}

	function getMainSrcset(url, initSize) {
		if (!url) return ''
		let result =
			url.replace('.png', '_' + initSize + 'x.png') +
			' ' +
			initSize +
			'w, '
		result +=
			url.replace('.png', '_' + Number(initSize) * 1.5 + 'x.png') +
			' ' +
			Number(initSize) * 1.5 +
			'w, '
		result +=
			url.replace('.png', '_' + Number(initSize) * 2 + 'x.png') +
			' ' +
			Number(initSize) * 2 +
			'w, '
		result +=
			url.replace('.png', '_' + Number(initSize) * 3 + 'x.png') +
			' ' +
			Number(initSize) * 3 +
			'w, '
		result +=
			url.replace('.png', '_' + Number(initSize) * 4 + 'x.png') +
			' ' +
			Number(initSize) * 4 +
			'w'
		return result
	}

	function getThumbSrcset(url, initSize) {
		if (!url) return ''
		let result = url.replace('.png', '_' + initSize + 'x.png') + ', '
		result +=
			url.replace('.png', '_' + Number(initSize) * 2 + 'x.png') + ' 2x'
		return result
	}

	function loadImages(imgEls, srcSets, srcs) {
		// For dev, when images aren't added yet
		if (![...imgEls].some(Boolean)) return Promise.resolve()
		for (let i = 0; i < imgEls.length; i++) {
			const image = imgEls[i]
			image.srcset = ''
			image.src = ''
		}
		let loadedImages = 0
		return new Promise((resolve, reject) => {
			for (let i = 0; i < imgEls.length; i++) {
				const image = imgEls[i]
				image.onload = function () {
					loadedImages++
					if (loadedImages === imgEls.length) {
						resolve()
					}
				}
				image.srcset = srcSets[i]
				image.src = srcs[i]
			}
		})
	}

	function changeThumb(e) {
		previewContainer.classList.add('opaque')
		previewLoader.classList.add('show')
		const el = e.currentTarget
		const thumbSide = Number(el.dataset.side)
		const mainImgEls = previewContainer.querySelectorAll('img')
		const selectedVariantIds = getSelectedVariantIds()
		const sideImages = getImages(selectedVariantIds, thumbSide)
		const srcs = []
		const srcSets = []
		for (
			let imageIndex = 0;
			imageIndex < el.querySelectorAll('img').length;
			imageIndex++
		) {
			srcSets.push(getMainSrcset(sideImages[imageIndex], '1000'))
			srcs.push(sideImages[imageIndex]?.replace('.png', '_1000x.png'))
		}

		loadImages(mainImgEls, srcSets, srcs).then(() => {
			Array.from(el.parentElement.children).forEach(function (
				containerEl
			) {
				containerEl.classList.remove('selected')
			})
			el.classList.add('selected')
			previewContainer.dataset.side = String(thumbSide)
			previewContainer.classList.remove('opaque')
			previewLoader.classList.remove('show')
		})
	}
	function openModal() {
		const imgContainer = previewModal.querySelector(
			'#preview-modal-img-container'
		)
		const side = Number(previewContainer.dataset.side)
		imgContainer.dataset.side = String(side)
		imgContainer.innerHTML = ''

		const selectedVariantIds = getSelectedVariantIds()
		const sideImages = getImages(selectedVariantIds, side)
		const newImages = []
		for (const image of sideImages) {
			const newImg = document.createElement('img')
			newImg.classList.add('hide')
			newImg.srcset = getMainSrcset(image, '1000')
			newImg.src = image?.replace('.png', '_1000x.png')
			imgContainer.appendChild(newImg)
			newImages.push(newImg)
		}
		previewModal.classList.add('show')
		newImages.forEach(function (img) {
			img.classList.remove('hide')
			img.classList.add('appear')
		})
	}

	function closeModal() {
		previewModal.classList.remove('show')
		const imgContainer = previewModal.querySelector(
			'#preview-modal-img-container'
		)
		imgContainer.innerHTML = ''
		imgContainer.dataset.side = null
	}

	function onPrevModalImg(e) {
		const imgContainer = previewModal.querySelector(
			'#preview-modal-img-container'
		)
		imgContainer.classList.add('opaque')
		setTimeout(function () {
			imgContainer.classList.remove('opaque')
		}, 100)
		imgContainer.innerHTML = ''
		const currSide = Number(imgContainer.dataset.side)
		const nextSide = currSide === 1 ? 4 : currSide - 1
		const selectedVariantIds = getSelectedVariantIds()
		const sideImages = getImages(selectedVariantIds, nextSide)

		const imgEls = []
		const srcSets = []
		const srcs = []

		for (let layerIndex = 0; layerIndex < LAYERS_COUNT; layerIndex++) {
			const layerImage = sideImages[layerIndex]
			const newImg = document.createElement('img')
			imgContainer.appendChild(newImg)
			imgEls.push(newImg)
			srcs.push(layerImage)
			srcSets.push(layerImage)
		}
		imgContainer.dataset.side = String(nextSide)

		loadImages(imgEls, srcSets, srcs)
	}

	function onNextModalImg(e) {
		const imgContainer = previewModal.querySelector(
			'#preview-modal-img-container'
		)
		imgContainer.classList.add('opaque')
		setTimeout(function () {
			imgContainer.classList.remove('opaque')
		}, 100)
		imgContainer.innerHTML = ''
		const currSide = Number(imgContainer.dataset.side)
		const nextSide = currSide === 4 ? 1 : currSide + 1
		const selectedVariantIds = getSelectedVariantIds()
		const sideImages = getImages(selectedVariantIds, nextSide)

		const imgEls = []
		const srcSets = []
		const srcs = []

		for (let layerIndex = 0; layerIndex < LAYERS_COUNT; layerIndex++) {
			const layerImage = sideImages[layerIndex]
			const newImg = document.createElement('img')
			imgContainer.appendChild(newImg)
			imgEls.push(newImg)
			srcs.push(layerImage)
			srcSets.push(layerImage)
		}
		imgContainer.dataset.side = String(nextSide)

		loadImages(imgEls, srcSets, srcs)
	}

	function setProductType() {
		const variantId = getSelectedVariantIds()[1]
		const variantTitle = partsData['lens'].variants[variantId].title
		if (/Cat. \d$/.test(variantTitle)) {
			const category = variantTitle[variantTitle.length - 1]
			const name = 'cat_' + variantTitle[variantTitle.length - 1]
			document
				.querySelectorAll('.product__tags--main .tag')
				.forEach(function (el) {
					el.classList.remove('is-selected')
				})
			const catEl = [
				...Array.from(
					document.querySelectorAll(
						'.product__tags--main .tag[data-type="' + name + '"]'
					)
				),
				...Array.from(
					document.querySelectorAll(
						'.product__tags--main .tag[data-type="' +
							name.replace('_', '-') +
							'"]'
					)
				),
			]

			catEl.forEach((el) => el.classList.add('is-selected'))
		}
	}

	function setupPreviewSwipe() {
		let startX
		let startY
		let isSwiping = false

		previewContainer.addEventListener('touchstart', handleTouchStart)
		previewContainer.addEventListener('touchmove', handleTouchMove)
		previewContainer.addEventListener('touchend', handleTouchEnd)

		function handleTouchStart(event) {
			startX = event.touches[0].pageX
			startY = event.touches[0].pageY
		}

		function handleTouchMove(event) {
			const deltaX = event.touches[0].pageX - startX
			const deltaY = event.touches[0].pageY - startY
			if (Math.abs(deltaX) > Math.abs(deltaY)) {
				event.preventDefault()
				isSwiping = true
			} else {
				isSwiping = false
			}
		}

		function handleTouchEnd(event) {
			if (isSwiping) {
				const deltaX = event.changedTouches[0].pageX - startX
				previewContainer.dispatchEvent(
					new CustomEvent('swipe', { detail: { deltaX } })
				)
			}
			isSwiping = false
		}
	}

	function onSwipe(deltaX) {
		if (Math.abs(deltaX) < 100) return
		const currSide = Number(previewContainer.dataset.side)
		let nextSide = currSide
		if (deltaX < 0) {
			if (currSide === 4) {
				nextSide = 1
			} else {
				nextSide += 1
			}
		} else {
			if (currSide === 1) {
				nextSide = 4
			} else {
				nextSide -= 1
			}
		}
		switch (nextSide) {
			case 1:
				return previewContainer1.click()
			case 2:
				return previewContainer2.click()
			case 3:
				return previewContainer3.click()
			case 4:
				return previewContainer4.click()
		}
	}

	async function closeBackInStock() {
		const backInStockPopupContainer = document.querySelector(
			'#BackInStockContainer-' + sectionId
		)
		backInStockPopupContainer.innerHTML = ''
		backInStockPopupContainer.style.display = 'none'
	}

	async function handleNotifySubmit(e) {
		e.preventDefault()
		const backInStockPopupContainer = document.querySelector(
			'#BackInStockContainer-' + sectionId
		)
		const errorMessage =
			backInStockPopupContainer.querySelector('#error_message')
		const successMessage =
			backInStockPopupContainer.querySelector('#completed_message')
		const formData = new FormData(e.target)
		try {
			successMessage.style.display = 'none'
			errorMessage.style.display = 'none'
			const res = await fetch(
				'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=QP6W8G',
				{
                    headers: {"Content-Type": "application/json", "Accept": "application/json", "revision": "2025-04-15"},
					method: 'POST',
					body: JSON.stringify({
                      data: {
                        "type": "back-in-stock-subscription",
                          "attributes": {
                            "channels": [
                              "EMAIL"
                            ],
                            "profile": {
                              "data": {
                                "type": "profile",
                                "attributes": {
                                  "email": formData.get("email")
                                }
                              }
                            }
                          },
                          "relationships": {
                            "variant": {
                              "data": {
                                "type": "catalog-variant",
                                "id": `$shopify:::$default:::${formData.get("variant")}`
                              }
                            }
                          }
                      }
                    }),
				}
			)
            if (!res.ok) {
    		  const data = await res.json()
              errorMessage.style.display = 'block'
              errorMessage.innerText =
                  data?.errors?.[0]?.detail ||
                  'There was an error with your request.'
			} else {
				successMessage.style.display = 'block'
				const closeLinkEl = document.querySelector('.bis-close')
				if (closeLinkEl) {
					closeLinkEl.addEventListener('click', function () {
						closeBackInStock()
					})
				}
			}
		} catch (error) {
            console.error(error)
			errorMessage.style.display = 'block'
			errorMessage.innerText = 'There was an error with your request.'
		}
	}

	async function onBackInStockClick() {
		const backInStockPopupContainer = document.querySelector(
			'#BackInStockContainer-' + sectionId
		)
		const urlParams = new URLSearchParams(document.location.search)
		const reqParams = new URLSearchParams()
		if (urlParams.has('variant')) {
			reqParams.set('variant', urlParams.get('variant'))
		}
		reqParams.set('section_id', 'customizable-product-notify-stock')
		const res = await fetch(
			window.location.pathname + '?' + reqParams.toString()
		)
		const text = await res.text()
		backInStockPopupContainer.innerHTML = text
		backInStockPopupContainer.style.display = 'block'
		backInStockPopupContainer
			.querySelector('form')
			.addEventListener('submit', handleNotifySubmit)
		backInStockPopupContainer
			.querySelector('.close')
			.addEventListener('click', closeBackInStock)
		backInStockPopupContainer
			.querySelector('#shopify-section-customizable-product-notify-stock')
			.addEventListener('click', function (e) {
				if (e.target === this) {
					closeBackInStock()
				}
			})
	}

	function updateMinicart(variantsTitle, price, isDisabled) {
		document.querySelector('.minicart .minicart__variant').innerText =
			variantsTitle
		document.querySelector('.minicart .price').innerText = price
	}

	function showWarnPopup() {
		warnPopup.classList.add('show')
	}

	function hideWarnPopup() {
		warnPopup.classList.remove('show')
	}

	function onConfirmWarnPopup() {
		hideWarnPopup()
		addToCart()
	}

	async function onAtcClick(e) {
		e.preventDefault()

		if (await hasCartDuplicates()) {
			showWarnPopup()
			return
		}

		addToCart()
	}

	async function hasCartDuplicates() {
		try {
			const selectedVariantIds = getSelectedVariantIds()
			const response = await fetch('/cart.js')
			const data = await response.json()
			const items = data.items
			const existingBundles = {}
			for (let i = 0; i < items.length; i++) {
				const item = items[i]
				const bundleId = item.properties._customizable_group_id
				if (!bundleId) continue
				if (!existingBundles[bundleId]) {
					existingBundles[bundleId] = []
				}
				existingBundles[bundleId].push(String(item.variant_id))
			}
			const allIds = Object.keys(existingBundles)
			for (let i = 0; i < allIds.length; i++) {
				const variantIds = existingBundles[allIds[i]]
				const hasOneCommon = variantIds.some(function (id) {
					return selectedVariantIds.includes(id)
				})
				const hasOneDifferent = variantIds.some(function (id) {
					return !selectedVariantIds.includes(id)
				})
				return hasOneCommon && hasOneDifferent
			}
		} catch (error) {
			console.error(error)
			return false
		}
	}

	async function addToCart(e) {
		const frameVariantId = frameForm.querySelector(
			'input[type=radio]:checked'
		).value
		const lensVariantId = lensForm.querySelector(
			'input[type=radio]:checked'
		).value
		const jawVariantId = jawForm?.querySelector(
			'input[type=radio]:checked'
		)?.value

		const bundleId = Date.now().toString()

		const selectedVariantIds = [frameVariantId, lensVariantId]
		if (
			partsData.jaw &&
			partsData.jaw.variants[Number(jawVariantId)].title !== 'None' &&
			jawToggle.checked
		) {
			selectedVariantIds.push(jawVariantId)
		}

		const items = selectedVariantIds.map((id) => ({
			id,
			quantity: 1,
			properties: { _customizable_group_id: bundleId },
		}))

		try {
			accessoryCheckboxes.forEach(function (checkbox) {
				if (checkbox.checked) {
					items.push({
						id: checkbox.dataset.variant,
						quantity: 1,
					})
				}
			})
		} catch (error) {
			console.error(error)
		}

		document.body.classList.add('js-loader-show')

		try {
			const response = await fetch('/cart/add.js', {
				headers: { 'Content-Type': 'application/json' },
				method: 'POST',
				body: JSON.stringify({ items }),
			})
			if (response.status !== 200) {
				document.body.classList.remove('js-loader-show')
				const data = await response.json()
				alert(data.description)
				return
			}
		} catch (e) {
			console.error(e)
			document.body.classList.remove('js-loader-show')
			return
		}

		document.body.classList.remove('js-loader-show')

		if (window.HSSLIDECART) {
			// HsCartDrawer.updateSlideCart()
			// HsCartDrawer.getSlideCart()
            window.HS_SLIDE_CART_UPDATE()
		} else {
			window.location.replace('/cart')
		}
	}
})()
